export default __webpack_public_path__ + "static/m-02-4d03ad39bd955ba803a3d3baebfb59cc.jpeg";